/* eslint-disable react/jsx-pascal-case */
/** @jsx jsx */
import React from 'react'
import { Link } from '../helpers/react'
import { Palette } from '../../utils/palette'
import { useDataSelector } from '../helpers/selectors'
import dayjs from '../../utils/date'
import { Type } from '@uswitch/spark'
import { jsx, Themed } from 'theme-ui'
import ImgixImg from '../helpers/ev-imgix/connected'

const TrustyleAuthor = ({
  title,
  subtitle,
  authorImage,
  titleUrl,
  variant,
  subtitleUrl,
  className,
}) => {
  const getVariant = (element) => `elements.author.${variant ? variant + '.' + element : element}`

  return (
    <div
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        variant: getVariant('base'),
      }}
      className={className}
    >
      <If condition={authorImage}>
        <Link
          href={titleUrl}
          sx={{
            flexShrink: 0,
            height: [40, 64],
            width: [40, 64],
            marginRight: 'sm',
            variant: getVariant('imageLink'),
          }}
        >
          <authorImage.type
            {...authorImage.props}
            sx={{
              maxHeight: '100%',
              maxWidth: '100%',
              borderRadius: '50%',
              variant: getVariant('image'),
            }}
          />
        </Link>
      </If>

      <div>
        <Type.Body2
          sx={{
            marginTop: 0,
            paddingBottom: 0,
            marginBottom: [0, 'xxs'],
            variant: getVariant('title'),
          }}
        >
          <Palette
            as={Themed.a}
            href={titleUrl}
            sx={{
              color: 'inherit',
              textDecoration: 'none',
              variant: getVariant('link'),
            }}
            px={{ color: 'textColor' }}
          >
            {title}
          </Palette>
        </Type.Body2>

        {subtitle && (
          <Type.Body2
            sx={{
              display: 'block',
              marginY: 0,
              variant: getVariant('subtitle'),
            }}
          >
            <Palette
              as={Themed.a}
              href={subtitleUrl}
              sx={{
                textDecoration: 'none',
                variant: getVariant('link'),
              }}
              px={{ color: 'textColor' }}
            >
              {subtitle}
            </Palette>
          </Type.Body2>
        )}
      </div>
    </div>
  )
}

const AuthorWithOptionalEditor = ({
  author,
  editor,
  verifier,
  publishDate,
  showWrittenBy = false,
}) => {
  const authorImage = (
    <ImgixImg
      entity={author?.image || author?.photo}
      width={100}
      height={100}
      imgixParams={{ fit: 'crop', crop: 'faces' }}
    />
  )
  const writtenByTitle = `${showWrittenBy ? 'Written by ' : ''}${author?.name}${
    author?.role ? `, ${author?.role}` : ``
  }`

  let editedBySubtitle
  let subtitleUrl = ''

  if (editor?.name) {
    editedBySubtitle = `Edited by ${editor.name}${editor.role ? `, ${editor.role}` : ''}`
    subtitleUrl = editor?.url
  } else if (verifier?.name) {
    editedBySubtitle = `Verified by ${verifier.name}${verifier.role ? `, ${verifier.role}` : ''}`
    subtitleUrl = verifier?.url
  }

  const fullSubtitle = publishDate
    ? [editedBySubtitle, dayjs(publishDate).format('LL')].filter((i) => i).join(', ')
    : editedBySubtitle

  return (
    <TrustyleAuthor
      authorImage={authorImage}
      title={writtenByTitle}
      titleUrl={author?.url}
      subtitle={fullSubtitle}
      subtitleUrl={subtitleUrl}
      variant={author?.variant}
    />
  )
}

const Author = (props) => {
  const { publishDate, updatedDate } = useDataSelector(['dates'])

  return <AuthorWithOptionalEditor {...props} publishedAt={publishDate} updatedAt={updatedDate} />
}

export default Author
